import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {WIZARD_COMPONENTS, WIZARD_PROVIDERS} from './wizard';
import {VALIDATION_DIRECTIVES, VALIDATION_PROVIDERS} from './validation';
import {COLLAPSE_COMPONENTS, COLLAPSE_PROVIDERS} from './collapse';
import {AUTO_COMPLETE_COMPONENTS, AUTO_COMPLETE_PROVIDERS} from './autocomplete';
import {FORM_DIRECTIVES} from './form';
import {TOGGLE_DIRECTIVES} from './toggle';
import {CHECKBOX_DIRECTIVES} from './checkbox';
import {NORMALIZER_DIRECTIVES} from './normalizers';
import {DATE_PICKER_DIRECTIVES} from './datepicker';
import {ACCORDION_DIRECTIVES} from './accordion';
import {LOADING_COMPONENTS} from './loading';
import {TEMPLATE_COMPONENTS} from './templates';
import {PAGINATION_COMPONENTS} from './pagination';
import {PANEL_COMPONENTS} from './panel';
import {CLICK_TO_EDIT_COMPONENTS} from './click-to-edit';
import {LOAD_MORE_COMPONENTS} from './load-more';
import {ICONS} from './icons';
import {FormsModule} from '@angular/forms';
import {AMOUNT_RANGE_COMPONENTS} from './amount';
import {TextareaAutoresize} from './textarea';
import {ErrorBlock} from '../../clients/app/modules/components/error/error.block';
import {ErrorWLBlock} from '../../clients/app/modules/components/errorwl/errorwl.block';
import {SuccessBlock} from '../../clients/app/modules/components/success/success.block';
import {NgxPaginationModule} from "ngx-pagination";
import {InputTrimDirective} from "./trim/trim.directive";
import {WarningBlockComponent} from '../../clients/app/modules/components/warning/warning-block.component';
import {MaterialCardComponent} from "./card/material-card.component";
import {CheckboxComponent} from "./category-checkbox";
import {MatCardModule} from "@angular/material/card";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {ChosenCategoryService} from "./business-category/chosen-category.service";
import {TooltipModule} from "ngx-bootstrap";

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        RouterModule,
        TranslateModule,
        NgxPaginationModule,
        MatCardModule,
        MatCheckboxModule,
        TooltipModule
    ],
    declarations: [
        InputTrimDirective,
        ...WIZARD_COMPONENTS,
        ...VALIDATION_DIRECTIVES,
        ...COLLAPSE_COMPONENTS,
        ...AUTO_COMPLETE_COMPONENTS,
        ...FORM_DIRECTIVES,
        ...TOGGLE_DIRECTIVES,
        ...CHECKBOX_DIRECTIVES,
        ...NORMALIZER_DIRECTIVES,
        ...DATE_PICKER_DIRECTIVES,
        ...ACCORDION_DIRECTIVES,
        ...LOADING_COMPONENTS,
        ...TEMPLATE_COMPONENTS,
        ...PAGINATION_COMPONENTS,
        ...PANEL_COMPONENTS,
        ...CLICK_TO_EDIT_COMPONENTS,
        ...LOAD_MORE_COMPONENTS,
        ...ICONS,
        ...AMOUNT_RANGE_COMPONENTS,
        TextareaAutoresize,
        ErrorBlock,
        ErrorWLBlock,
        SuccessBlock,
        WarningBlockComponent,
        MaterialCardComponent,
        CheckboxComponent
    ],
    providers: [
        ...WIZARD_PROVIDERS,
        ...VALIDATION_PROVIDERS,
        ...COLLAPSE_PROVIDERS,
        ...AUTO_COMPLETE_PROVIDERS,
        ChosenCategoryService
    ],
    exports: [
        NgxPaginationModule,

        // MdMenuModule,
        InputTrimDirective,
        ...WIZARD_COMPONENTS,
        ...VALIDATION_DIRECTIVES,
        ...COLLAPSE_COMPONENTS,
        ...AUTO_COMPLETE_COMPONENTS,
        ...FORM_DIRECTIVES,
        ...TOGGLE_DIRECTIVES,
        ...CHECKBOX_DIRECTIVES,
        ...NORMALIZER_DIRECTIVES,
        ...DATE_PICKER_DIRECTIVES,
        ...ACCORDION_DIRECTIVES,
        ...LOADING_COMPONENTS,
        ...TEMPLATE_COMPONENTS,
        ...PAGINATION_COMPONENTS,
        ...PANEL_COMPONENTS,
        ...CLICK_TO_EDIT_COMPONENTS,
        ...LOAD_MORE_COMPONENTS,
        ...ICONS,
        ...AMOUNT_RANGE_COMPONENTS,
        TextareaAutoresize,
        ErrorBlock,
        ErrorWLBlock,
        SuccessBlock,
        WarningBlockComponent,
        MaterialCardComponent,
        CheckboxComponent
    ]
})
export class CommonComponentsModule {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/common.components.module.ts